__turbopack_context__.v({
  "divider": "TripPriceBreakdownModal-module__eqprBq__divider",
  "iconBadge": "TripPriceBreakdownModal-module__eqprBq__iconBadge",
  "itemLabel": "TripPriceBreakdownModal-module__eqprBq__itemLabel",
  "itemLabelMuted": "TripPriceBreakdownModal-module__eqprBq__itemLabelMuted",
  "itemList": "TripPriceBreakdownModal-module__eqprBq__itemList",
  "learnMoreLink": "TripPriceBreakdownModal-module__eqprBq__learnMoreLink",
  "listItem": "TripPriceBreakdownModal-module__eqprBq__listItem",
  "pricingNote": "TripPriceBreakdownModal-module__eqprBq__pricingNote",
  "pricingNoteText": "TripPriceBreakdownModal-module__eqprBq__pricingNoteText",
  "questionBadge": "TripPriceBreakdownModal-module__eqprBq__questionBadge",
  "root": "TripPriceBreakdownModal-module__eqprBq__root",
  "sectionTitle": "TripPriceBreakdownModal-module__eqprBq__sectionTitle",
});
